import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField
} from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import AppButton from "../../common/AppButton";
import { useStockItems } from "../../../hooks/api/education/useStockItem";
import { CreateStockRequisitionInput } from "./types/stockRequisition";

type Props = {
  open: boolean;
  onClose: () => void;
  loading?: boolean;
  onSubmit: (input: CreateStockRequisitionInput) => Promise<void>;
};

const StockRequisitionForm: React.FC<Props> = ({
  open,
  onClose,
  loading,
  onSubmit
}) => {
  const { t } = useKivunovaTranslation();
  const { data: stockItems = [] } = useStockItems({ size: 100 });
  const [purpose, setPurpose] = useState("");
  const [stockItemId, setStockItemId] = useState("");
  const [quantity, setQuantity] = useState("1");

  const handleSubmit = async () => {
    const selected = stockItems.find((item) => item.id === stockItemId);
    if (!stockItemId || !quantity) return;
    await onSubmit({
      purpose: purpose.trim() || undefined,
      lines: [
        {
          stockItemId,
          stockItemName: selected?.name,
          quantity: Number(quantity),
          unit: selected?.baseUnit
        }
      ]
    });
    setPurpose("");
    setStockItemId("");
    setQuantity("1");
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("new-stock-request", "New request")}</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 1 }}
      >
        <TextField
          label={t("purpose", "Purpose")}
          value={purpose}
          onChange={(e) => setPurpose(e.target.value)}
          fullWidth
        />
        <TextField
          select
          label={t("stock-item", "Stock item")}
          value={stockItemId}
          onChange={(e) => setStockItemId(e.target.value)}
          fullWidth
        >
          {stockItems.map((item) => (
            <MenuItem key={item.id} value={item.id}>
              {item.name} ({item.quantityOnHand ?? 0})
            </MenuItem>
          ))}
        </TextField>
        <TextField
          label={t("quantity", "Quantity")}
          type="number"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value)}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <AppButton variant="outlined" onClick={onClose}>
          {t("cancel", "Cancel")}
        </AppButton>
        <AppButton onClick={handleSubmit} disabled={!stockItemId || loading}>
          {t("create", "Create")}
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default StockRequisitionForm;
